import React from "react";
import "./App.css";

const Wrapper = ({ children }) => {
  return (
    <div className="outer-wrapper">
      <div className="inner-wrapper">{children}</div>
    </div>
  );
};

export default Wrapper;
